import { Action, ActionReducer } from '@ngrx/store/src/models';
import { createLoadWithPaginationActions, LoadWithPaginationActions } from './actions';
import { createLoadWithPaginationReducer, LoadWithPaginationState } from './reducer';
import { createLoadWithPaginationSelectors, LoadWithPaginationSelectors } from './selectors';
import { GenericEntity, StateAdapter } from '../types';
import { getDefaultLoadState } from '../load/adapter';

export interface LoadWithPaginationAdapter<Entity>
  extends StateAdapter<
    LoadWithPaginationActions<Entity>,
    LoadWithPaginationSelectors<Entity>,
    ActionReducer<LoadWithPaginationState<Entity>, Action>,
    LoadWithPaginationState<Entity>
  > {}

export const getDefaultLoadWithPaginationState = <Entity>(): LoadWithPaginationState<Entity> => ({
  ...getDefaultLoadState<Entity>(),
  pagination: {
    limit: 10,
    page: 1,
    total: 0,
  },
  sort: null,
});

export function createLoadWithPaginationAdapter<Entity = GenericEntity>(options: {
  stateKey: string;
  type: string;
  primaryKey?: string;
  initialState?: Partial<LoadWithPaginationState<Entity>>;
}): LoadWithPaginationAdapter<Entity> {
  const { type, stateKey, primaryKey = 'id', initialState } = options;
  const hydratedInitialState: LoadWithPaginationState<Entity> = {
    ...getDefaultLoadWithPaginationState<Entity>(),
    primaryKey,
    ...initialState,
  };
  const actions = createLoadWithPaginationActions<Entity>(type);
  const reducer = createLoadWithPaginationReducer<Entity>(hydratedInitialState, actions);
  const selectors = createLoadWithPaginationSelectors<Entity>(stateKey);

  return {
    getActions: () => actions,
    getSelectors: () => selectors,
    getReducer: () => reducer,
    getInitialState: () => hydratedInitialState,
  };
}
